import React, { ReactElement, useContext } from "react";
import TemplateHeader from "../../Header/TemplateHeader";
import { templateActionEnum } from "../../../Config/Constants";
import TemplateDataContext from "../../../Contexts/TemplateData.context";
import Offcanvas from "react-bootstrap/Offcanvas";
import Nav from "../TemplateStep/Nav";
import HorizontalNavigation from "../TemplateStep/HorizontalNavigation";
import useLoadSteps from "../../../Hooks/LoadSteps";

type Props = {
  template: string;
  uri: string;
  stepName: string;
  isHideSteps: string[];
};

const SideNavbar = ({
  template,
  uri,
  stepName,
  isHideSteps,
}: Props): ReactElement => {
  const { state, dispatch } = useContext(TemplateDataContext);
  const {
    templates,
    stepNumber,
    totalSteps,
    activeTemplateSteps,
    sideNavbarState,
  } = state;

  /* side navbar handler */
  const handleClose = () =>
    dispatch({ type: templateActionEnum.SET_NAVBAR_STATE, payload: false });
  const handleShow = () =>
    dispatch({ type: templateActionEnum.SET_NAVBAR_STATE, payload: true });

  // COMMENTED OUT - Progress indicator no longer needed since progress bar is removed
  // const [progressIndicator, setProgressIndicator] = useState<number>(0)

  useLoadSteps({
    templates,
  });

  /* COMMENTED OUT - Calculate the progress indicator - no longer needed */
  /* useEffect(() => {
        if (Object.keys(templates).length > 0 && activeTemplateSteps.length > 0) {
            let currentStepNumber = activeTemplateSteps.findIndex((x) => x[jsonKeyMapping.SLUGIFY] === stepName)
            currentStepNumber = currentStepNumber === -1 ? 0 : currentStepNumber
            const totalStepsCount = totalSteps || activeTemplateSteps.length
            setProgressIndicator((currentStepNumber + 1) / totalStepsCount * 100)
        }
        return () => { }
    }, [stepName, totalSteps, activeTemplateSteps.length, templates, stepNumber]) */

  return (
    <>
      {/* HORIZONTAL NAVIGATION FOR MOBILE/TABLET */}
      <HorizontalNavigation uri={uri} isHideSteps={isHideSteps} />

      {/* DESKTOP SIDEBAR */}
      <div className="leftmenu">
        {/* <TemplateHeader handleShow={handleShow} handleClose={handleClose} isOpen={sideNavbarState} /> */}
        <Nav isHideSteps={isHideSteps} uri={uri} show={sideNavbarState} />
      </div>
      {/* MOBILE NAVBAR */}
      <Offcanvas show={sideNavbarState} onHide={handleClose} backdrop={false}>
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <Nav isHideSteps={isHideSteps} show={sideNavbarState} uri={uri} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SideNavbar;
